import { api, secureCall } from 'utils/api';

export const getRatioCooptationsHired = secureCall((params) => api.get('kpi/ratio-cooptations-hired', { params }));
export const getCountCooptationsByHr = secureCall((params) => api.get('kpi/count-cooptations-by-hr', { params }));
export const getCountCooptationsByEntity = secureCall((params) =>
  api.get('kpi/count-cooptations-by-entity', { params })
);
